import axios from 'axios'
import { getWalletsKeyCloakApi } from 'keycloak/keycloakApis'
import { getBrowserDetail } from 'utils/helpers'
import { encryptCryptoJSData, encryptMessagePublicKey } from '../utils/cryotoUtils'
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API,
  timeout: 500000
})
axiosInstance.interceptors.request.use(
  async (config) => {
    // const data = config.data
    // let key = process.env.REACT_APP_ENC_PUBLIC_KEY
    // const hash = encryptMessagePublicKey(JSON.stringify(data), key)

    // config.data = { signature: hash }
    return config
  },
  (error) => {
    console.log('axios.interceptors error')
    return error
  }
)

export const verifyMissingRiddleSucccess = async (riddleDocID, ssoAccessToken) => {
  try {
    const twitterRetweetUrl = `/verifyRiddleSuccessStatus`

    const data = {
      riddle_id: riddleDocID,
      time_completed: 0
    }
    let key = process.env.REACT_APP_ENC_PUBLIC_KEY
    const hash = encryptMessagePublicKey(JSON.stringify(data), key)

    const responce = await axiosInstance.post(
      twitterRetweetUrl,
      {
        signature: hash
      },
      {
        headers: {
          Authorization: `bearer ${ssoAccessToken}`
        }
      }
    )
    return responce?.data ?? null
  } catch (error) {
    console.log('error::', error)
    return error?.response?.data ?? null
  }
}

export const getUserRiddleInformation = async (riddleID, ssoAccessToken) => {
  try {
    const twitterRetweetUrl = `/userRiddle`

    const data = {
      riddle_id: riddleID
    }
    let key = process.env.REACT_APP_ENC_PUBLIC_KEY
    const hash = encryptMessagePublicKey(JSON.stringify(data), key)

    const responce = await axiosInstance.post(
      twitterRetweetUrl,
      {
        signature: hash
      },
      {
        headers: {
          Authorization: `bearer ${ssoAccessToken}`
        }
      }
    )
    return responce?.data ?? null
  } catch (error) {
    console.log('error::', error)
    return error?.response?.data ?? null
  }
}
export const getUserRiddleSuccessStatusInformation = async (riddleID, ssoAccessToken) => {
  try {
    const twitterRetweetUrl = `/userRiddleSuccessShareStatus`

    const data = {
      riddle_id: riddleID
    }
    let key = process.env.REACT_APP_ENC_PUBLIC_KEY
    const hash = encryptMessagePublicKey(JSON.stringify(data), key)

    const responce = await axiosInstance.post(
      twitterRetweetUrl,
      {
        signature: hash
      },
      {
        headers: {
          Authorization: `bearer ${ssoAccessToken}`
        }
      }
    )
    return responce?.data ?? null
  } catch (error) {
    console.log('error::', error)
    return error?.response?.data ?? null
  }
}

// export const getSignatureApi = async (data, ssoAccessToken) => {
//   try {
//     const twitterRetweetUrl = `/txSignature`

//     let key = process.env.REACT_APP_ENC_PUBLIC_KEY
//     const hash = encryptMessagePublicKey(JSON.stringify(data), key)

//     const responce = await axiosInstance.post(
//       twitterRetweetUrl,
//       {
//         signature: hash
//       },
//       {
//         headers: {
//           Authorization: `bearer ${ssoAccessToken}`
//         }
//       }
//     )
//     return responce?.data ?? null
//   } catch (error) {
//     console.log('error::', error)
//     return error?.response?.data ?? null
//   }
// }

export const getMintingTxnsStatus = async (txns) => {
  try {
    const twitterRetweetUrl = `/txnsStatus`

    const responce = await axiosInstance.post(twitterRetweetUrl, {
      txns
    })
    return responce?.data?.data ?? null
  } catch (error) {
    console.log('error::', error)
    return error?.response?.data ?? null
  }
}
export const getGardianMintStatus = async (data, ssoAccessToken) => {
  try {
    const twitterRetweetUrl = `/checkGardianMintingStatus`

    let key = process.env.REACT_APP_ENC_PUBLIC_KEY
    const hash = encryptMessagePublicKey(JSON.stringify(data), key)

    const responce = await axiosInstance.post(
      twitterRetweetUrl,
      {
        signature: hash
      },
      {
        headers: {
          Authorization: `bearer ${ssoAccessToken}`
        }
      }
    )
    return responce?.data ?? null
  } catch (error) {
    console.log('error::', error)
    return error?.response?.data ?? null
  }
}
export const getCurrentActiveRiddle = async (ssoAccessToken) => {
  if (ssoAccessToken) {
    try {
      const twitterRetweetUrl = `/currentRiddle`
      const data = {
        game_id: process.env.REACT_APP_GAME_ID
      }
      let key = process.env.REACT_APP_ENC_PUBLIC_KEY
      const hash = encryptMessagePublicKey(JSON.stringify(data), key)
      const responce = await axiosInstance.post(
        twitterRetweetUrl,
        {
          signature: hash
        },
        {
          headers: {
            Authorization: `bearer ${ssoAccessToken}`
          }
        }
      )
      return responce?.data ?? null
    } catch (error) {
      console.log('error::', error)
      return error?.response?.data ?? null
    }
  }
}
export const syncWalletsPoints = async (ssoAccessToken) => {
  let wallets = []
  try {
    const walletsRes = await getWalletsKeyCloakApi()
    if (walletsRes.success && walletsRes.data) {
      wallets = walletsRes.data
    }
  } catch (error) {}

  try {
    if (wallets?.length > 0) {
      const walletsList = []
      wallets?.forEach((element) => {
        walletsList.push(element.walletAddress?.toLowerCase())
      })

      const browserDetail = getBrowserDetail()
      const walletsPointsSync = `/syncWallets`

      const data = {
        game_id: process.env.REACT_APP_GAME_ID,
        version: browserDetail?.version ?? '',
        device_id: browserDetail?.device_id ?? '',
        platform: 'web'
      }
      let key = process.env.REACT_APP_ENC_PUBLIC_KEY
      const hash = encryptMessagePublicKey(JSON.stringify(data), key)
      const responce = await axiosInstance.post(
        walletsPointsSync,
        {
          signature: hash,
          walletsAddress: walletsList
        },
        {
          headers: {
            Authorization: `bearer ${ssoAccessToken}`
          }
        }
      )
    }
  } catch (error) {
    console.log('syncWalletsPoints Error===>', error)
  }
  return wallets
}
